import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AdminGuard = ({ children }) => {
  const { user, userProfile, loading } = useAuth();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Checking permissions...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/user-login" replace />;
  }

  // Redirect to main dashboard if not admin
  if (!userProfile || userProfile.role !== 'admin') {
    return <Navigate to="/game-library-dashboard" replace />;
  }

  // Render admin content if user is admin
  return children;
};

export default AdminGuard;
